import { FC } from 'react';
import classNames from 'classnames';

type Props = {
  className?: string;
};

const Applications: FC<Props> = ({ className }) => (
  <svg
    className={classNames('w-[20px] h-[20px] stroke-[1.5px]', className)}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.84146 1.19512C8.84146 0.811217 9.15268 0.5 9.53659 0.5H13.2439C13.4283 0.5 13.6051 0.573236 13.7354 0.703597L15.5891 2.55726C15.8605 2.82872 15.8605 3.26884 15.5891 3.54031L13.7354 5.39396C13.6051 5.52433 13.4283 5.59756 13.2439 5.59756H10.2317V8.84146H15.0976C16.2652 8.84146 17.3849 9.30529 18.2106 10.1309C19.0362 10.9565 19.5 12.0763 19.5 13.2439V18.8049C19.5 19.1888 19.1888 19.5 18.8049 19.5H1.19512C0.811217 19.5 0.5 19.1888 0.5 18.8049V12.7805C0.5 11.7358 0.915003 10.7339 1.65371 9.99518C2.39242 9.25647 3.39433 8.84146 4.43902 8.84146H8.84146V1.19512ZM10.2317 4.20732H12.956L14.1145 3.04878L12.956 1.89024H10.2317V4.20732ZM7.44231 10.2317C8.04418 10.9408 8.37805 11.8435 8.37805 12.7805V18.1098H18.1098V13.2439C18.1098 12.445 17.7924 11.6789 17.2275 11.114C16.6626 10.5491 15.8964 10.2317 15.0976 10.2317H7.44231ZM6.9878 18.1098V12.7805C6.9878 12.1045 6.71927 11.4562 6.24128 10.9782C5.7633 10.5002 5.115 10.2317 4.43902 10.2317C3.76305 10.2317 3.11475 10.5002 2.63676 10.9782C2.15878 11.4562 1.89024 12.1045 1.89024 12.7805V18.1098H6.9878ZM3.28049 13.2439C3.28049 12.86 3.5917 12.5488 3.97561 12.5488H4.90244C5.28634 12.5488 5.59756 12.86 5.59756 13.2439C5.59756 13.6278 5.28634 13.939 4.90244 13.939H3.97561C3.5917 13.939 3.28049 13.6278 3.28049 13.2439Z"
      fill="currentColor"
      strokeWidth="currentStrokeWidth"
    />
  </svg>
);

export default Applications;
